import React, { useRef, useState } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { Menu } from 'primereact/menu'
import { Avatar } from 'primereact/avatar'
import image from '../../Assets/2.png'
import './SidebarCSS.css'
import { ConfirmDialog } from 'primereact/confirmdialog'
import { FaClipboardUser } from "react-icons/fa6";
import { FaBoxes, FaBoxOpen, FaBuilding, FaCheckCircle, FaClipboard, FaClipboardCheck, FaClipboardList, FaClock, FaCogs, FaExchangeAlt, FaFileAlt, FaFileInvoice, FaFileInvoiceDollar, FaFlask, FaHashtag, FaHome, FaIndustry, FaLayerGroup, FaListAlt, FaRetweet, FaShapes, FaShippingFast, FaShoppingCart, FaSitemap, FaStore, FaTags, FaTasks, FaThermometerHalf, FaTools, FaTruck, FaTruckLoading, FaUser, FaUserCheck, FaWarehouse } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";

const HeaderNav = ({ handleLogout }) => {
    const location = useLocation();

     // Mapping route paths to page titles
  const pageTitles = {
    "/dashboard": { title: "Dashboard", icon: <FaHome size={16} /> },
    "/gm1": { title: "Designation Master", icon: <FaUserTie size={16} /> },
    "/gm2": { title: "Department Master", icon: <FaBuilding size={16} /> },
    "/gm3": { title: "Employee Master", icon: <FaUser size={16} /> },
    "/gm4": { title: "Alloy Master", icon: <FaFlask size={16} /> },
    "/gm5": { title: "Press Master", icon: <FaCogs size={16} /> },
    "/gm6": { title: "Job Worker Master", icon: <FaTruck size={16} /> },
    "/gm7": { title: "HSN Code Master", icon: <FaHashtag size={16} /> },

    "/gm8": { title: "Bank Detail Master", icon: <FaHashtag size={16} /> },
    // "/gm9": { title: "UOM Master", icon: <FaHashtag size={16} /> },
    "/gm10": { title: "Supplier Master", icon: <FaHashtag size={16} /> },
    // "/gm11": { title: "Job Worker Process Master", icon: <FaHashtag size={16} /> },
    // "/gm12": { title: "Job Worker Item Master", icon: <FaHashtag size={16} /> },


    "/purchasem1": { title: "Terms & Conditions Master", icon: <FaHashtag size={16} /> },

    "/dm1": { title: "Die Category Master", icon: <FaListAlt size={16} /> },
    "/dm2": { title: "Die SubCategory Master", icon: <FaSitemap size={16} /> },
    "/dm3": { title: "Die Name Master", icon: <FaShapes size={16} /> },
    // "/dm4": { title: "Dies Master", icon: <FaCogs size={16} /> },
    // "/dm5": { title: "Die Assembly Master", icon: <FaLayerGroup size={16} /> },
    // "/dm6": { title: "Dia Master", icon: <FaSitemap size={16} /> },

    "/sm1": { title: "Customer Master", icon: <FaUserCheck size={16} /> },
    "/sm2": { title: "Consignee Master", icon: <FaStore size={16} /> },
    "/sm3": { title: "Rate Master", icon: <FaTags size={16} /> },

    // "/pm1": { title: "Machine Master", icon: <FaTools size={16} /> },
    "/pm2": { title: "Rack Master", icon: <FaLayerGroup size={16} /> },
    // "/pm3": { title: "Shift Master", icon: <FaClock size={16} /> },
    "/pm4": { title: "Temper Master", icon: <FaThermometerHalf size={16} /> },

    // "/dieshop1": { title: "NI Trading Entry", icon: <FaExchangeAlt size={16} /> },
    // "/dieshop2": { title: "Die Status Change", icon: <FaClipboardCheck size={16} /> },
    // "/dieshop3": { title: "Die Wise Report", icon: <FaFileAlt size={16} /> },
    // "/dieshop4": { title: "Die Name Wise Report", icon: <FaFileAlt size={16} /> },
    // "/dieshop5": { title: "NI Trading Due Report", icon: <FaFileAlt size={16} /> },
    // "/dieshop6": { title: "Customer Wise Die Report", icon: <FaFileAlt size={16} /> },

    "/sales1": { title: "Order Entry", icon: <FaClipboardList size={16} /> },
    "/sales2": { title: "Pre Order Entry", icon: <FaClipboard size={16} /> },
    "/sales3": { title: "Order Status", icon: <FaCheckCircle size={16} /> },
    "/sales4": { title: "Job Sheet Approval", icon: <FaClipboardCheck size={16} /> },
    "/sales5": { title: "Rate Approval", icon: <FaTags size={16} /> },
    "/sales6": { title: "Job Sheet Closure Status", icon: <FaClipboardUser size={16} /> },
    "/sales7": { title: "Order Allotment", icon: <FaTasks size={16} /> },
    "/sales8": { title: "Stock Checking", icon: <FaTasks size={16} /> },
    "/jobsheet-details/:orderId": { title: "Job Sheet Details", icon: <FaClipboardCheck size={16} /> },
    "/ratesheet-details/:orderId": { title: "Rate Sheet Details", icon: <FaTags size={16} /> },
    "/orderallotment-details/:orderId": { title: "Order Allotment Details", icon: <FaTasks size={16} /> },

    "/salesorder1": { title: "Sales Item Wise Report", icon: <FaWarehouse size={16} /> }, 
    "/salesorder2": { title: "Sales Detail Register", icon: <FaWarehouse size={16} /> }, 
    "/salesorder3": { title: "Packing List Report", icon: <FaWarehouse size={16} /> }, 
    "/salesorder4": { title: "Item Stock Report", icon: <FaWarehouse size={16} /> }, 
    "/salesorder5": { title: "Rack Wise Details", icon: <FaWarehouse size={16} /> }, 

    "/porder1": { title: "Pending Order Summary", icon: <FaBoxOpen size={16} /> },
    "/porder2": { title: "Order Paper", icon: <FaShoppingCart size={16} /> },

    // "/production1": { title: "Press Input", icon: <FaIndustry size={16} /> },
    "/production2": { title: "Press Output", icon: <FaIndustry size={16} /> },
    "/production3": { title: "Close Rack", icon: <FaBoxes size={16} /> },
    "/production4": { title: "Ageing", icon: <FaRetweet size={16} /> },
    "/production5": { title: "Rack Remark", icon: <FaFileAlt size={16} /> },
    "/production6": { title: "Packing Details Entry", icon: <FaBoxOpen size={16} /> },
    // "/production7": { title: "Release Rack", icon: <FaTruckLoading size={16} /> },

    "/preport1": { title: "Ageing Report", icon: <FaFileAlt size={16} /> },
    "/preport2": { title: "Packing Rejection Report", icon: <FaFileAlt size={16} /> },
    "/preport3": { title: "Manufacture Report", icon: <FaFileAlt size={16} /> },

    "/dispatch1": { title: "Dispatch", icon: <FaShippingFast size={16} /> },
    "/dispatch2": { title: "Job Work", icon: <FaIndustry size={16} /> },
    "/dispatch3": { title: "Job Work Dispatch", icon: <FaTruck size={16} /> },
    "/dispatch4": { title: "Miscellaneous Update", icon: <FaRetweet size={16} /> },
    "/dispatch5": { title: "Dispatch Delivery Summary", icon: <FaRetweet size={16} /> },
    "/dispatch6": { title: "Job Work Delivery Summary", icon: <FaRetweet size={16} /> },

    "/quotation1": { title: "Quotation", icon: <FaFileInvoice size={16} /> },
    "/quotation2": { title: "Proforma Invoice", icon: <FaFileInvoiceDollar size={16} /> },
    "/pinvoice1": { title: "Proforma Invoice", icon: <FaFileInvoiceDollar size={16} /> },
  };

   // Get the current page title based on the route, default to "Dashboard"
  //  const currentPage = pageTitles[location.pathname] || { title: "Dashboard", icon: <FaHome size={16} /> };

    // Match the current path against known routes (including dynamic)
  let currentPage = { title: "Dashboard", icon: <FaHome size={16} /> };

  Object.entries(pageTitles).forEach(([path, config]) => {
    if (matchPath(path, location.pathname)) {
      currentPage = config;
    }
  });



  const [visible, setVisible] = useState(false)
  const menuRef = useRef(null)

  const confirmLogout = () => {
    setVisible(true)
  }
  const viewProfile = () => {}
  const viewSettings = () => {}


  const menuItems = [
    {
      label: 'Profile',
      icon: (
        <span className="fa-solid fa-user" style={{ color: '#0466c8' }}></span>
      ),
      command: viewProfile,
    },
    {
      label: 'Settings',
      icon: (
        <span className="fa-solid fa-gear" style={{ color: '#0466c8' }}></span>
      ),
     command: viewSettings,
    },
    {
      label: 'Logout',
      icon: (
        <span
          className="fa-solid fa-right-from-bracket"
          style={{ color: '#0466c8' }}
        ></span>
      ),
      command: confirmLogout,
    },
  ]

  return (
    <>

    <div className="row m-0 p-0 head">

      <div className="col-6 py-1 pt-2">
            <h5 className="" style={{ letterSpacing: '2px',fontWeight:"bold" }}>Sangli Aluminium Extrusions Pvt. Ltd.</h5>
      </div>

      <div className='col-6 py-1 pt-2 text-end'>
        <Menu
          model={menuItems}
          popup
          ref={menuRef}
          id="popup_menu"
          className="text-center"
        />
        <Avatar
          image={image}
          shape="circle"
          size="large"
          className="cursor-pointer"
          onClick={(event) => menuRef.current.toggle(event)}
          aria-controls="popup_menu"
          aria-haspopup
          style={{ border: '1px solid grey' }}
        />

        <div>
          <ConfirmDialog
            className="custom-confirm-dialog"
            visible={visible}
            onHide={() => setVisible(false)}
            message="Are you sure you want to log out?"
            header="Logout Confirmation"
            icon="pi pi-exclamation-triangle"
            acceptLabel="Log Out"
            rejectLabel="Cancel"
            acceptClassName="p-button-danger"
            rejectClassName="p-button-secondary"
            accept={handleLogout}
            reject={() => setVisible(false)}
          />
        </div>
      </div>

    </div>

        <div className="row m-0 p-0 menuName pt-1">
            <h5 className="ps-4 mb-6"> {currentPage.icon}  {currentPage.title}</h5>
        </div>
    </>
  )
}

export default HeaderNav
